export const SEARCH_ADS = 'creatives'
export const SEARCH_APPS = 'apps'
export const SEARCH_NEW_ADS = 'adsNew'
export const SEARCH_ADS_CLASSIC = 'adsClassic'
export const WELCOME_SHOW_MODAL = 'welcome-show-modal'

export const SEARCH_CONFIG = {
  apps: {
    fetchList: (...args) =>
      import('@/common/services/api').then(({ appsApi }) =>
        appsApi.getApps(...args)
      ),
    fetchItemDetails: (...args) =>
      import('@/common/services/api').then(({ appsApi }) =>
        appsApi.getAppsDetails(...args)
      ),
    fetchConfig: (...args) =>
      import('@/common/services/api').then(({ appsApi }) =>
        appsApi.getFiltersConfig(...args)
      ),
    queryId: 'app_id',
    isClassic: false,
  },
  creatives: {
    fetchList: (...args) =>
      import('@/common/services/api').then(({ creativesApi }) =>
        creativesApi.getCreatives(...args)
      ),
    fetchConfig: (...args) =>
      import('@/common/services/api').then(({ creativesApi }) =>
        creativesApi.getFiltersConfig(...args)
      ),
    fetchItemDetails: (...args) =>
      import('@/common/services/api').then(({ creativesApi }) =>
        creativesApi.getCreativeDetails(...args)
      ),
    queryId: 'ad_id',
    isClassic: false,
  },
  adsClassic: {
    fetchList: (...args) =>
      import('@/common/services/api').then(({ creativesApi }) =>
        creativesApi.getCreatives(...args)
      ),
    fetchConfig: (...args) =>
      import('@/common/services/api').then(({ creativesApi }) =>
        creativesApi.getFiltersConfig(...args, {
          mode: 'classic',
        })
      ),
    fetchItemDetails: (...args) =>
      import('@/common/services/api').then(({ creativesApi }) =>
        creativesApi.getCreativeDetails(...args)
      ),
    queryId: 'ad_id',
    isClassic: true,
  },
}

export const TYPE_LIST = [
  {
    icon: 'grid-icon',
    value: 'grid',
  },
  {
    icon: 'list-icon',
    value: 'list',
  },
]
